import { AuthenticationContext, AdalConfig } from "react-adal";
import { apiUrl, uiUrl, clientId } from "./message";

export const adalConfig: AdalConfig = {
  clientId: `${clientId}`,
  redirectUri: `${uiUrl}`,
  endpoints: {
    api: `${apiUrl}`,
  },
  cacheLocation: "localStorage",
};

export const authContext = new AuthenticationContext(adalConfig);

export const getToken = () => {
  let token = authContext.getCachedToken(adalConfig.clientId);
  
  if (!token) {
    authContext.logOut();
  }
  return token;
}

export const GetUserInFo = () => authContext.getCachedUser();
